import { ChangeEvent, ReactNode } from 'react';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material';
import SearchInputWithTooltip from '../../../common/SearchInputWithTooltip';
import { globalSearchSx } from '../../../pages/canvas-pages/canvasPanelConsts';

export interface SearchInputProps {
  searchTxt: string;
  tempSearchTxt: string;
  isExpandedMode: boolean;
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onClearButtonClick: () => void;
  placeholder?: string;
  endAdornment?: ReactNode;
  forceCloseButton?: boolean;
  size?: 'small' | 'default';
  autoFocus?: boolean;
  onFocus?: () => void;
  textFieldSx?: SxProps<Theme>;
}

export const SearchInput = ({
  searchTxt,
  tempSearchTxt,
  isExpandedMode,
  onKeyDown,
  onChange,
  onClearButtonClick,
  placeholder = 'Search all elements...',
  endAdornment,
  forceCloseButton = !!searchTxt,
  size,
  autoFocus = true,
  onFocus,
  textFieldSx,
}: SearchInputProps) => {
  const displayTooltip = !!tempSearchTxt && tempSearchTxt !== searchTxt;

  return (
    <Box sx={{ ...globalSearchSx(isExpandedMode), borderRadius: 0, width: '100%' }}>
      <Box maxWidth={isExpandedMode ? '348px' : 'auto'}>
        <SearchInputWithTooltip
          displayTooltip={displayTooltip}
          onClearButtonClick={onClearButtonClick}
          withFixedMagnifyingGlassIcon
          forceCloseButton={forceCloseButton}
          endAdornment={endAdornment}
          size={size}
          autoFocus={autoFocus}
          TextFieldProps={{
            onChange,
            value: tempSearchTxt,
            placeholder,
            onKeyDown,
            onFocus,
            sx: textFieldSx,
          }}
        />
      </Box>
    </Box>
  );
};
